import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    load: 'currentOnly',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    fallbackLng: 'en',
    supportedLngs: [
      'ar',
      'de',
      'en',
      'es',
      'fr',
      'id',
      'it',
      'ja',
      'nl',
      'pl',
      'pt',
      'ru',
      'th',
      'tr',
      'zh_CN',
      'zh_TW'
    ],
    // List of namespaces (modules) preloaded on init and on every changeLanguage.
    // 'content' is in here because the human-made badge renders it on every page, so it has
    // to be fetched up front rather than lazily on first badge render.
    // Keep 'skill_bite' first: i18next derives defaultNS from ns[0].
    ns: ['skill_bite', 'content'],
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true
    }
  })

export default i18n
